// The dashboard's button: sentence case, rounded as the sidebar's rows are.
// `primary` takes the green edge, green being an accent and never a fill;
// `secondary` is quiet; `ghost` has no edge, for actions inside a row;
// `danger` is for what can't be undone; `danger-ghost` is that inside a
// table row, red without an edge. `size="sm"` fits a list row; `size="lg"` stands
// beside a 44px search field.
const BASE = "inline-flex cursor-pointer items-center justify-center gap-[6px] whitespace-nowrap border leading-none transition-colors duration-150 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-[color:var(--green)] disabled:cursor-not-allowed disabled:opacity-50";

const SIZES = {
    lg: "h-[44px] rounded-[7px] px-[16px] text-[14px]",
    md: "h-[32px] rounded-[7px] px-[12px] text-[13px]",
    sm: "h-[26px] rounded-[6px] px-[8px] text-[12px]",
};

const VARIANTS = {
    primary: "border-[color:var(--green)] bg-[color-mix(in_srgb,var(--ink)_9%,transparent)] font-medium text-[color:var(--ink)] hover:bg-[color-mix(in_srgb,var(--ink)_15%,transparent)]",
    secondary: "border-[color:var(--line-strong)] bg-transparent text-[color:var(--muted)] hover:bg-[color-mix(in_srgb,var(--ink)_7%,transparent)] hover:text-[color:var(--ink)]",
    ghost: "border-transparent bg-transparent text-[color:var(--muted)] hover:bg-[color-mix(in_srgb,var(--ink)_9%,transparent)] hover:text-[color:var(--ink)]",
    danger: "border-[color:var(--red,#c0392b)] bg-transparent font-medium text-[color:var(--red,#c0392b)] hover:bg-[color-mix(in_srgb,var(--red,#c0392b)_16%,transparent)]",
    "danger-ghost": "border-transparent bg-transparent text-[color:var(--red,#c0392b)] hover:bg-[color-mix(in_srgb,var(--red,#c0392b)_14%,transparent)]",
};

/** The classes alone, for a link or label that should look like a button. */
export function buttonClass(variant = "secondary", size = "md") {
    return `${BASE} ${SIZES[size] ?? SIZES.md} ${VARIANTS[variant] ?? VARIANTS.secondary}`;
}

export default function Button({ variant = "secondary", size = "md", type = "button", className = "", ...props }) {
    return <button type={type} {...props} className={`${buttonClass(variant, size)} ${className}`} />;
}
